import { render, staticRenderFns } from "./ScreenForm.vue?vue&type=template&id=31ec7489"
import script from "./ScreenForm.vue?vue&type=script&lang=js"
export * from "./ScreenForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports